import React from "react";
import PropTypes from "prop-types";

import { money } from "../../utils/helpers";
import PrefixedInput from "./PrefixedInput";

// Casilla de Retención + el/los montos retenidos + el "Monto Recibido" que
// resulta de restarlos. Lo usan cuentas por cobrar (una retención por cuenta
// seleccionada, `retencion[]`) y el pago de facturas (una sola, `retencion`).
//
// Los valores viven en el componente que llama: cuentas por cobrar los
// inicializa al abrir el modal y los vuelve a mostrar en la pantalla de
// confirmación.
// Con la retención encendida hay que indicar cuánto se retiene. Los campos van
// `required`, lo que basta donde el formulario se envía de verdad (cuentas por
// cobrar valida con checkValidity antes de pasar a la confirmación); los pagos de
// factura despachan el submit a mano, que se salta la validación del navegador,
// así que ahí se llama a esto antes de guardar.
export const faltaMontoRetencion = (retenciones = []) =>
	retenciones.length === 0 || retenciones.some((valor) => !(Number(valor) > 0));

const RetencionFields = ({
	activa,
	onToggle,
	pago,
	retenciones,
	setRetenciones,
	cuentas = [],
	retencionesPorDefecto = [],
}) => {
	const porCuenta = cuentas.length > 0;

	// Un campo vacío retiene cero: el monto recibido vuelve a ser la deuda
	// completa. No se sustituye por el valor por defecto, que sólo se siembra al
	// encender la casilla.
	const totalRetenido = retenciones.reduce(
		(total, valor) => total + (Number(valor) || 0),
		0
	);

	const alternar = () => {
		if (!activa) setRetenciones(retencionesPorDefecto);
		onToggle();
	};

	const actualizar = (indice, valor) =>
		setRetenciones(
			(porCuenta ? cuentas : [null]).map((_, i) =>
				i === indice ? valor : retenciones[i]
			)
		);

	return (
		<>
			<div className="form-group m-t-15">
				<input
					type="checkbox"
					className="m-r-10"
					onChange={alternar}
				/>
				<small className="uppercase">Retención</small>
				{activa &&
					(porCuenta ? (
						cuentas.map((cuenta, index) => (
							<div className="d-flex mb-1 w-100" key={cuenta.numeracion}>
								{cuentas.length > 1 && (
									<label className="bold my-auto mr-2">
										{cuenta.numeracion}
									</label>
								)}
								<div className="col m-0 p-0">
									<PrefixedInput
										type="number"
										prefix="RD$"
										name="retencion[]"
										required
										value={retenciones[index] ?? ""}
										setValue={(e) => actualizar(index, e)}
									/>
								</div>
							</div>
						))
					) : (
						<PrefixedInput
							type="number"
							prefix="RD$"
							name="retencion"
							required
							value={retenciones[0] ?? ""}
							setValue={(e) => actualizar(0, e)}
						/>
					))}
			</div>
			{activa && (
				<div className="form-group m-t-15">
					<label>Monto Recibido</label>
					<PrefixedInput
						readOnly
						type="number"
						prefix="RD$"
						name="monto_recibido_con_retencion"
						value={money(pago - totalRetenido)}
					/>
				</div>
			)}
		</>
	);
};

RetencionFields.propTypes = {
	activa: PropTypes.bool,
	onToggle: PropTypes.func,
	pago: PropTypes.any,
	retenciones: PropTypes.array,
	setRetenciones: PropTypes.func,
	cuentas: PropTypes.array,
	retencionesPorDefecto: PropTypes.array,
};

export default RetencionFields;
